import { NOT_FOUND } from 'redux-first-router'

const controllers: {[index: string]: string} = {
  LOAD: 'LoadScreen',
  HOME: 'MainController',
  CHANNEL: 'MainController',
  LOGIN: 'AuthController',
  [NOT_FOUND]: 'NotFound'
}

const subPages: {[index: string]: string} = {
  LOGIN: 'Login',
}

type PageState = {
  controller: string,
  subPage: string | null
}

const initialState: PageState = {
  controller: 'LoadScreen',
  subPage: null
}

export default (state = initialState, action: {type: string}): PageState => typeof controllers[action.type] !== "undefined" ? {
    controller: controllers[action.type], subPage: subPages[action.type]??null
  } : state;